import cx from 'classnames';
import { func, number } from 'prop-types';
import * as classNames from './PageNav.module.css';

const PageNav = (props) => {
  const { currentPage, maxPageCount, onChange, totalPages } = props;
  const allPages = [];
  let i;

  for (i = 1; i <= totalPages; i++) {
    allPages.push({
      num: i,
    });
  }

  const start = Math.max(Math.min(currentPage - maxPageCount / 2, totalPages - maxPageCount), 0);

  const end = Math.max(Math.max(currentPage + maxPageCount / 2, maxPageCount / 2), maxPageCount);
  const pagesInView = allPages.slice(start, end);

  const active = (pg) => (pg === currentPage ? 'active' : '');

  return (
    <div className={classNames.container}>
      <div className={classNames.buttonsContainer}>
        <button
          type="button"
          className={cx(classNames.arrow, {
            [classNames.prevInactive]: currentPage === 1,
          })}
          onClick={() => {
            if (currentPage > 1) {
              onChange(currentPage - 1);
            }
          }}
        >
          <i className="fas fa-caret-left" />
        </button>
        {pagesInView.map((page) => (
          <button
            type="button"
            key={page.num}
            className={cx(classNames.pageButton, {
              [classNames.active]: active(page.num),
            })}
            onClick={() => {
              onChange(page.num);
            }}
          >
            <p className={classNames.pageNum}>{page.num}</p>
          </button>
        ))}
        <button
          type="button"
          className={cx(classNames.arrow, {
            [classNames.nextInactive]: currentPage === pagesInView.length,
          })}
          onClick={() => {
            if (currentPage < totalPages) {
              onChange(currentPage + 1);
            }
          }}
        >
          <i className="fas fa-caret-right" />
        </button>
      </div>
    </div>
  );
};

PageNav.propTypes = {
  currentPage: number.isRequired,
  maxPageCount: number.isRequired,
  onChange: func.isRequired,
  totalPages: number.isRequired,
};

export default PageNav;
